import RpcClass from "../../../../../server/RpcClass.js";

import yaml from "js-yaml"

import RpcNotFoundException from "../../../../../server/com/silkplm/engine/rpc/exceptions/RpcNotFoundException.js";

let locale;
if(typeof window !== "undefined") {
    locale = window?.navigator?.userLanguage || window?.navigator?.language || Intl.DateTimeFormat().resolvedOptions().locale;
} else {
    locale= RpcClass.locale = Intl.DateTimeFormat().resolvedOptions().locale;
}

const FULL_CLASS = 'com.silkplm.model.plm.Tranche';

import LocalDate from "../../../../../server/LocalDate.js";
import LocalDateTime from "../../../../../server/LocalDateTime.js";
import LocalTime from "../../../../../server/LocalTime.js";



class Tranche extends RpcClass{

    /**
     *  @class Tranche
     *  @alias module:src/server/com/silkplm/model/plm/Tranche.Tranche
     *  
     * */
    constructor(){
        super();

        /** @type {BigDecimal}  */
        this.CBMField = null;
        /** @type {string}  */
        this.EID = null;
        /** @type {LocalDate}  */
        this.ETDConfirmed = null;
        /** @type {boolean}  */
        this.ETDConfirmedWarning = null;
        /** @type {string}  */
        this.SKUNumberOfOrdersForTheColorVersion = null;
        /** @type {boolean}  */
        this.__archived = null;
        /** @type {number}  */
        this.__familyId = null;
        /** @type {boolean}  */
        this.__hidden = null;
        /** @type {number}  */
        this.__parent = null;
        /** @type {Date}  */
        this.__versionDate = null;
        /** @type {Object.<string, *>}  */
        this._translations = null;
        /** @type {module:src/server/com/silkplm/model/files/FileInRepository.FileInRepository[]}  */
        this.attachments = null;
        /** @type {LocalDate}  */
        this.booking = null;
        /** @type {BigDecimal}  */
        this.cartonsField = null;
        /** @type {string}  */
        this.country = null;
        /** @type {string}  */
        this.currentSelectedRegion = null;
        /** @type {LocalDate}  */
        this.date = null;
        /** @type {LocalDate}  */
        this.dateOfInvoice = null;
        /** @type {string}  */
        this.deliveryPort = null;
        /** @type {string}  */
        this.deliveryType = null;
        /** @type {string}  */
        this.descriptionDPP = null;
        /** @type {boolean}  */
        this.documents = null;
        /** @type {BigDecimal}  */
        this.grossWeight = null;
        /** @type {string}  */
        this.id = null;
        /** @type {boolean}  */
        this.inspection = null;
        /** @type {string}  */
        this.integrationStatus = null;
        /** @type {string}  */
        this.invoiceNumberField = null;
        /** @type {boolean}  */
        this.noAdditionalCosts = null;
        /** @type {string}  */
        this.numberOfTranche = null;
        /** @type {string}  */
        this.orderId = null;
        /** @type {string}  */
        this.port = null;
        /** @type {boolean}  */
        this.rawMaterialsPath = null;
        /** @type {LocalDate}  */
        this.realEXW = null;
        /** @type {module:src/server/com/silkplm/engine/entities/tracking/RecordMetadata.RecordMetadata}  */
        this.recordMetadata = null;
        /** @type {string}  */
        this.stateOfSubiektIntegration = null;
        /** @type {string}  */
        this.statusShipment = null;
        /** @type {string}  */
        this.transportType = null;
        /** @type {string}  */
        this.typeOfDocument = null;
        /** @type {BigDecimal}  */
        this.valueOfInvoice = null;
        /** @type {number}  */
        this.version = null;
        /** @type {string}  */
        this.warehouse = null;

        if(window["SessionManager"]?.isLoggedIn()){
            const formConfig = window['FormsLoader']?.detectFormConfig(FULL_CLASS);
            for(const f of formConfig.fields){
                if(f.formDisabled){
                    continue;
                }
                if( f.defaultValue !== null) {
                    this[f.fieldName] = yaml.load(f.defaultValue);
                }
             }
        }
    }



    /**
     * Get extension tab: Quality Control And Additional Costs
     * @returns {Promise<QualityControlAndAdditionalCosts>}
     */

    async getQualityControlAndAdditionalCosts(){
        return Rpc.Forms.getEntityExtension(
            FULL_CLASS,
            this.id,
            "trancheId",
            "com.silkplm.model.plm.QualityControlAndAdditionalCosts");
   }
    /**
     * Get extension tab: Booking
     * @returns {Promise<Booking>}
     */

    async getBooking(){
        return Rpc.Forms.getEntityExtension(
            FULL_CLASS,
            this.id,
            "trancheId",
            "com.silkplm.model.plm.Booking");
   }


    /** @type {number}  */
    get orderIdNumberOfOrder(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['orderIdNumberOfOrder'] : null, this.__metadata__['orderIdNumberOfOrder']?.remoteType);
    }
    set orderIdNumberOfOrder(val){
    }
    // fk: false

    /** @type {string}  */
    get orderIdSeasonId(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['orderIdSeasonId'] : null, this.__metadata__['orderIdSeasonId']?.remoteType);
    }
    set orderIdSeasonId(val){
    }
    // fk: true
    /** @returns {Promise<String>} */
    getOrderIdSeasonIdLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.Season', 'orderIdSeasonId',  allowRemote); //  false 
    }

    /** @returns {String} */
    getOrderIdSeasonIdStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.Season', 'orderIdSeasonId'); //  false 
    }

    /** @returns {Promise<Season>} */
    getOrderIdSeasonIdEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.Season', 'orderIdSeasonId',  allowRemote); //  false 
    }

    /** @type {string}  */
    get orderIdSupplierIdSupplierCode(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['orderIdSupplierIdSupplierCode'] : null, this.__metadata__['orderIdSupplierIdSupplierCode']?.remoteType);
    }
    set orderIdSupplierIdSupplierCode(val){
    }
    // fk: false

    /** @type {string}  */
    get orderIdSupplierId(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['orderIdSupplierId'] : null, this.__metadata__['orderIdSupplierId']?.remoteType);
    }
    set orderIdSupplierId(val){
    }
    // fk: true
    /** @returns {Promise<String>} */
    getOrderIdSupplierIdLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.Suppliers', 'orderIdSupplierId',  allowRemote); //  false 
    }

    /** @returns {String} */
    getOrderIdSupplierIdStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.Suppliers', 'orderIdSupplierId'); //  false 
    }

    /** @returns {Promise<Suppliers>} */
    getOrderIdSupplierIdEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.Suppliers', 'orderIdSupplierId',  allowRemote); //  false 
    }

    /** @type {LocalDate}  */
    get aTA(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['aTA'] : null, this.__metadata__['aTA']?.remoteType);
    }
    set aTA(val){
    }


    /** @type {LocalDate}  */
    get aTD(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['aTD'] : null, this.__metadata__['aTD']?.remoteType);
    }
    set aTD(val){
    }


    /** @type {BigDecimal}  */
    get balanceTotal(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['balanceTotal'] : null, this.__metadata__['balanceTotal']?.remoteType);
    }
    set balanceTotal(val){
    }


    /** @type {boolean}  */
    get bookingPMApproval(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['bookingPMApproval'] : null, this.__metadata__['bookingPMApproval']?.remoteType);
    }
    set bookingPMApproval(val){
    }


    /** @type {boolean}  */
    get confirmedETDValid(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['confirmedETDValid'] : null, this.__metadata__['confirmedETDValid']?.remoteType);
    }
    set confirmedETDValid(val){
    }


    /** @type {boolean}  */
    get countryValid(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['countryValid'] : null, this.__metadata__['countryValid']?.remoteType);
    }
    set countryValid(val){
    }


    /** @type {boolean}  */
    get currencyValid(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['currencyValid'] : null, this.__metadata__['currencyValid']?.remoteType);
    }
    set currencyValid(val){
    }


    /** @type {boolean}  */
    get depositDeducted(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['depositDeducted'] : null, this.__metadata__['depositDeducted']?.remoteType);
    }
    set depositDeducted(val){
    }


    /** @type {LocalDate}  */
    get eTA(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['eTA'] : null, this.__metadata__['eTA']?.remoteType);
    }
    set eTA(val){
    }


    /** @type {LocalDate}  */
    get eTD(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['eTD'] : null, this.__metadata__['eTD']?.remoteType);
    }
    set eTD(val){
    }


    /** @type {string}  */
    get invoiceNumber(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['invoiceNumber'] : null, this.__metadata__['invoiceNumber']?.remoteType);
    }
    set invoiceNumber(val){
    }


    /** @type {string}  */
    get orderNumberERP(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['orderNumberERP'] : null, this.__metadata__['orderNumberERP']?.remoteType);
    }
    set orderNumberERP(val){
    }


    /** @type {module:src/server/com/silkplm/rpc/dto/DecimalWithCurrency.DecimalWithCurrency}  */
    get orderValue(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['orderValue'] : null, this.__metadata__['orderValue']?.remoteType);
    }
    set orderValue(val){
    }


    /** @type {LocalDate}  */
    get paymentDeadline(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['paymentDeadline'] : null, this.__metadata__['paymentDeadline']?.remoteType);
    }
    set paymentDeadline(val){
    }


    /** @type {LocalDate}  */
    get plannedDateOfInspection(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['plannedDateOfInspection'] : null, this.__metadata__['plannedDateOfInspection']?.remoteType);
    }
    set plannedDateOfInspection(val){
    }


    /** @type {boolean}  */
    get portValid(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['portValid'] : null, this.__metadata__['portValid']?.remoteType);
    }
    set portValid(val){
    }


    /** @type {string}  */
    get productCategory(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['productCategory'] : null, this.__metadata__['productCategory']?.remoteType);
    }
    set productCategory(val){
    }


    /** @type {*[]}  */
    get productsOnTranche(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['productsOnTranche'] : null, this.__metadata__['productsOnTranche']?.remoteType);
    }
    set productsOnTranche(val){
    }


    /** @type {boolean}  */
    get qCPMApproval(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['qCPMApproval'] : null, this.__metadata__['qCPMApproval']?.remoteType);
    }
    set qCPMApproval(val){
    }


    /** @type {number}  */
    get quantity(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['quantity'] : null, this.__metadata__['quantity']?.remoteType);
    }
    set quantity(val){
    }


    /** @type {number}  */
    get quantitySKU(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['quantitySKU'] : null, this.__metadata__['quantitySKU']?.remoteType);
    }
    set quantitySKU(val){
    }


    /** @type {BigDecimal}  */
    get valuePLN(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['valuePLN'] : null, this.__metadata__['valuePLN']?.remoteType);
    }
    set valuePLN(val){
    }


    /** @type {string}  */
    get warehouseIntegrationCode(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['warehouseIntegrationCode'] : null, this.__metadata__['warehouseIntegrationCode']?.remoteType);
    }
    set warehouseIntegrationCode(val){
    }


    /**
     * @param val {BigDecimal}
     * @returns {module:src/server/com/silkplm/model/plm/Tranche.Tranche}
     */
    withCBMField(val){
        let rawValue = val;
        let v = val;
        v = new BigDecimal(rawValue)
        this.CBMField = v;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/Tranche.Tranche}
     */
    withEID(val){
        this.EID = val;
        return this;
    };


    /**
     * @param val {LocalDate}
     * @returns {module:src/server/com/silkplm/model/plm/Tranche.Tranche}
     */
    withETDConfirmed(val){
        let rawValue = val;
        let v = val;
        v = new LocalDate(); v.value = rawValue;
        this.ETDConfirmed = v;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/model/plm/Tranche.Tranche}
     */
    withETDConfirmedWarning(val){
        this.ETDConfirmedWarning = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/Tranche.Tranche}
     */
    withSKUNumberOfOrdersForTheColorVersion(val){
        this.SKUNumberOfOrdersForTheColorVersion = val;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/model/plm/Tranche.Tranche}
     */
    with__archived(val){
        this.__archived = val;
        return this;
    };


    /**
     * @param val {number}
     * @returns {module:src/server/com/silkplm/model/plm/Tranche.Tranche}
     */
    with__familyId(val){
        this.__familyId = val;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/model/plm/Tranche.Tranche}
     */
    with__hidden(val){
        this.__hidden = val;
        return this;
    };


    /**
     * @param val {number}
     * @returns {module:src/server/com/silkplm/model/plm/Tranche.Tranche}
     */
    with__parent(val){
        this.__parent = val;
        return this;
    };


    /**
     * @param val {Date}
     * @returns {module:src/server/com/silkplm/model/plm/Tranche.Tranche}
     */
    with__versionDate(val){
        let rawValue = val;
        let v = val;
        v = new Date(rawValue)
        this.__versionDate = v;
        return this;
    };


    /**
     * @param val {Object.<string, *>}
     * @returns {module:src/server/com/silkplm/model/plm/Tranche.Tranche}
     */
    with_translations(val){
        this._translations = val;
        return this;
    };


    /**
     * @param val {module:src/server/com/silkplm/model/files/FileInRepository.FileInRepository[]}
     * @returns {module:src/server/com/silkplm/model/plm/Tranche.Tranche}
     */
    withAttachments(val){
        this.attachments = val;
        return this;
    };


    /**
     * @param val {LocalDate}
     * @returns {module:src/server/com/silkplm/model/plm/Tranche.Tranche}
     */
    withBooking(val){
        let rawValue = val;
        let v = val;
        v = new LocalDate(); v.value = rawValue;
        this.booking = v;
        return this;
    };


    /**
     * @param val {BigDecimal}
     * @returns {module:src/server/com/silkplm/model/plm/Tranche.Tranche}
     */
    withCartonsField(val){
        let rawValue = val;
        let v = val;
        v = new BigDecimal(rawValue)
        this.cartonsField = v;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/Tranche.Tranche}
     */
    withCountry(val){
        this.country = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getCountryLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.dictionaries.Country', 'country', allowRemote); //  true 
    }

    /** @returns {String} */
        getCountryStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.dictionaries.Country', 'country'); //  true 
    }

        /** @returns {Promise<Country>} */
    getCountryEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.dictionaries.Country', 'country', allowRemote); //  true 
    }

    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/Tranche.Tranche}
     */
    withCurrentSelectedRegion(val){
        this.currentSelectedRegion = val;
        return this;
    };


    /**
     * @param val {LocalDate}
     * @returns {module:src/server/com/silkplm/model/plm/Tranche.Tranche}
     */
    withDate(val){
        let rawValue = val;
        let v = val;
        v = new LocalDate(); v.value = rawValue;
        this.date = v;
        return this;
    };


    /**
     * @param val {LocalDate}
     * @returns {module:src/server/com/silkplm/model/plm/Tranche.Tranche}
     */
    withDateOfInvoice(val){
        let rawValue = val;
        let v = val;
        v = new LocalDate(); v.value = rawValue;
        this.dateOfInvoice = v;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/Tranche.Tranche}
     */
    withDeliveryPort(val){
        this.deliveryPort = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getDeliveryPortLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.dictionaries.DeliveryPort', 'deliveryPort', allowRemote); //  true 
    }

    /** @returns {String} */
        getDeliveryPortStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.dictionaries.DeliveryPort', 'deliveryPort'); //  true 
    }

        /** @returns {Promise<DeliveryPort>} */
    getDeliveryPortEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.dictionaries.DeliveryPort', 'deliveryPort', allowRemote); //  true 
    }

    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/Tranche.Tranche}
     */
    withDeliveryType(val){
        this.deliveryType = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getDeliveryTypeLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.dictionaries.DeliveryType', 'deliveryType', allowRemote); //  true 
    }

    /** @returns {String} */
        getDeliveryTypeStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.dictionaries.DeliveryType', 'deliveryType'); //  true 
    }

        /** @returns {Promise<DeliveryType>} */
    getDeliveryTypeEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.dictionaries.DeliveryType', 'deliveryType', allowRemote); //  true 
    }

    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/Tranche.Tranche}
     */
    withDescriptionDPP(val){
        this.descriptionDPP = val;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/model/plm/Tranche.Tranche}
     */
    withDocuments(val){
        this.documents = val;
        return this;
    };


    /**
     * @param val {BigDecimal}
     * @returns {module:src/server/com/silkplm/model/plm/Tranche.Tranche}
     */
    withGrossWeight(val){
        let rawValue = val;
        let v = val;
        v = new BigDecimal(rawValue)
        this.grossWeight = v;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/Tranche.Tranche}
     */
    withId(val){
        this.id = val;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/model/plm/Tranche.Tranche}
     */
    withInspection(val){
        this.inspection = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/Tranche.Tranche}
     */
    withIntegrationStatus(val){
        this.integrationStatus = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getIntegrationStatusLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.dictionaries.StatusIntegrationLogger', 'integrationStatus', allowRemote); //  true 
    }

    /** @returns {String} */
        getIntegrationStatusStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.dictionaries.StatusIntegrationLogger', 'integrationStatus'); //  true 
    }

        /** @returns {Promise<StatusIntegrationLogger>} */
    getIntegrationStatusEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.dictionaries.StatusIntegrationLogger', 'integrationStatus', allowRemote); //  true 
    }

    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/Tranche.Tranche}
     */
    withInvoiceNumberField(val){
        this.invoiceNumberField = val;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/model/plm/Tranche.Tranche}
     */
    withNoAdditionalCosts(val){
        this.noAdditionalCosts = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/Tranche.Tranche}
     */
    withNumberOfTranche(val){
        this.numberOfTranche = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/Tranche.Tranche}
     */
    withOrderId(val){
        this.orderId = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getOrderIdLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.Order', 'orderId', allowRemote); //  true 
    }

    /** @returns {String} */
        getOrderIdStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.Order', 'orderId'); //  true 
    }

        /** @returns {Promise<Order>} */
    getOrderIdEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.Order', 'orderId', allowRemote); //  true 
    }

    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/Tranche.Tranche}
     */
    withPort(val){
        this.port = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getPortLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.dictionaries.Port', 'port', allowRemote); //  true 
    }

    /** @returns {String} */
        getPortStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.dictionaries.Port', 'port'); //  true 
    }

        /** @returns {Promise<Port>} */
    getPortEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.dictionaries.Port', 'port', allowRemote); //  true 
    }

    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/model/plm/Tranche.Tranche}
     */
    withRawMaterialsPath(val){
        this.rawMaterialsPath = val;
        return this;
    };


    /**
     * @param val {LocalDate}
     * @returns {module:src/server/com/silkplm/model/plm/Tranche.Tranche}
     */
    withRealEXW(val){
        let rawValue = val;
        let v = val;
        v = new LocalDate(); v.value = rawValue;
        this.realEXW = v;
        return this;
    };


    /**
     * @param val {module:src/server/com/silkplm/engine/entities/tracking/RecordMetadata.RecordMetadata}
     * @returns {module:src/server/com/silkplm/model/plm/Tranche.Tranche}
     */
    withRecordMetadata(val){
        this.recordMetadata = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/Tranche.Tranche}
     */
    withStateOfSubiektIntegration(val){
        this.stateOfSubiektIntegration = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getStateOfSubiektIntegrationLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.dictionaries.IntegrationStatuses', 'stateOfSubiektIntegration', allowRemote); //  true 
    }

    /** @returns {String} */
        getStateOfSubiektIntegrationStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.dictionaries.IntegrationStatuses', 'stateOfSubiektIntegration'); //  true 
    }

        /** @returns {Promise<IntegrationStatuses>} */
    getStateOfSubiektIntegrationEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.dictionaries.IntegrationStatuses', 'stateOfSubiektIntegration', allowRemote); //  true 
    }

    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/Tranche.Tranche}
     */
    withStatusShipment(val){
        this.statusShipment = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getStatusShipmentLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.dictionaries.OrderDetailsShipmentStatus', 'statusShipment', allowRemote); //  true 
    }

    /** @returns {String} */
        getStatusShipmentStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.dictionaries.OrderDetailsShipmentStatus', 'statusShipment'); //  true 
    }

        /** @returns {Promise<OrderDetailsShipmentStatus>} */
    getStatusShipmentEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.dictionaries.OrderDetailsShipmentStatus', 'statusShipment', allowRemote); //  true 
    }

    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/Tranche.Tranche}
     */
    withTransportType(val){
        this.transportType = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getTransportTypeLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.dictionaries.TransportType', 'transportType', allowRemote); //  true 
    }

    /** @returns {String} */
        getTransportTypeStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.dictionaries.TransportType', 'transportType'); //  true 
    }

        /** @returns {Promise<TransportType>} */
    getTransportTypeEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.dictionaries.TransportType', 'transportType', allowRemote); //  true 
    }

    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/Tranche.Tranche}
     */
    withTypeOfDocument(val){
        this.typeOfDocument = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getTypeOfDocumentLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.dictionaries.TypeOfDocument', 'typeOfDocument', allowRemote); //  true 
    }

    /** @returns {String} */
        getTypeOfDocumentStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.dictionaries.TypeOfDocument', 'typeOfDocument'); //  true 
    }

        /** @returns {Promise<TypeOfDocument>} */
    getTypeOfDocumentEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.dictionaries.TypeOfDocument', 'typeOfDocument', allowRemote); //  true 
    }

    /**
     * @param val {BigDecimal}
     * @returns {module:src/server/com/silkplm/model/plm/Tranche.Tranche}
     */
    withValueOfInvoice(val){
        let rawValue = val;
        let v = val;
        v = new BigDecimal(rawValue)
        this.valueOfInvoice = v;
        return this;
    };


    /**
     * @param val {number}
     * @returns {module:src/server/com/silkplm/model/plm/Tranche.Tranche}
     */
    withVersion(val){
        this.version = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/Tranche.Tranche}
     */
    withWarehouse(val){
        this.warehouse = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getWarehouseLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.dictionaries.Warehouse', 'warehouse', allowRemote); //  true 
    }

    /** @returns {String} */
        getWarehouseStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.dictionaries.Warehouse', 'warehouse'); //  true 
    }

        /** @returns {Promise<Warehouse>} */
    getWarehouseEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.dictionaries.Warehouse', 'warehouse', allowRemote); //  true 
    }



    /**
    * @param {string[]?} fields
    * @returns {Promise<Tranche>}
    */
    async save(fields){
        return this.__save(FULL_CLASS, fields);
    }

    async load(id=null){
        if(id == null){
            id = this.id;
        }
        let newVersion = await loadTranche(id);
        for(const k in newVersion){
            this[k] = newVersion[k];
        }
    }
    /**
     * @return {Promise}
     */
    async delete(){
        return Rpc.Forms.deleteEntity(FULL_CLASS, this.id);
    }
    /**
     * @param {*|string} replacementIdOrInst
     * @return {Promise}
     */
    async deleteWithReplacement(replacementIdOrInst){
        if(replacementIdOrInst.hasOwnProperty('id')){
            replacementIdOrInst = replacementIdOrInst.id;
        }
        return Rpc.Forms.deleteEntityWithReplacement(FULL_CLASS, this.id, replacementIdOrInst);
    }
    /**
     * CAN_DELETE | SUGGEST_REPLACEMENT | FORCE_REPLACEMENT | DELETE_RESTRICTED | DELETE_NOT_PERMITTED
     * @return {Promise<String>>}
     */
    async canDelete(){
        return Rpc.Forms.canDeleteEntity(FULL_CLASS, this.id);
    }

    /**
     * @param fieldName
     * @returns {Promise<FieldValidationResult>}
     */
    async validateField(fieldName){
        return Rpc.Forms.validateField(FULL_CLASS, fieldName, this[fieldName], this.id);
    }

    /**
     * @returns {Promise<InputValidationResult>}
     */
    async checkConstraints(){
        return Rpc.Forms.checkConstraints(FULL_CLASS, this);
    }
    /** @returns {Promise<String>}*/
    async getFkFieldLabel(fiendName, allowRemote=false) {
        if(fiendName === 'orderIdSeasonId'){
            return this.getOrderIdSeasonIdLabel(allowRemote);
        }
        if(fiendName === 'orderIdSupplierId'){
            return this.getOrderIdSupplierIdLabel(allowRemote);
        }
        if(fiendName === 'country'){
            return this.getCountryLabel(allowRemote);
        }
        if(fiendName === 'deliveryPort'){
            return this.getDeliveryPortLabel(allowRemote);
        }
        if(fiendName === 'deliveryType'){
            return this.getDeliveryTypeLabel(allowRemote);
        }
        if(fiendName === 'integrationStatus'){
            return this.getIntegrationStatusLabel(allowRemote);
        }
        if(fiendName === 'orderId'){
            return this.getOrderIdLabel(allowRemote);
        }
        if(fiendName === 'port'){
            return this.getPortLabel(allowRemote);
        }
        if(fiendName === 'stateOfSubiektIntegration'){
            return this.getStateOfSubiektIntegrationLabel(allowRemote);
        }
        if(fiendName === 'statusShipment'){
            return this.getStatusShipmentLabel(allowRemote);
        }
        if(fiendName === 'transportType'){
            return this.getTransportTypeLabel(allowRemote);
        }
        if(fiendName === 'typeOfDocument'){
            return this.getTypeOfDocumentLabel(allowRemote);
        }
        if(fiendName === 'warehouse'){
            return this.getWarehouseLabel(allowRemote);
        }

        return '';
    }

    /** @returns {Promise<*>}*/
    async getFkFieldEntity(fiendName, allowRemote=false) {
        if(fiendName === 'country'){
            return this.getCountryEntity(allowRemote);
        }
        if(fiendName === 'deliveryPort'){
            return this.getDeliveryPortEntity(allowRemote);
        }
        if(fiendName === 'deliveryType'){
            return this.getDeliveryTypeEntity(allowRemote);
        }
        if(fiendName === 'integrationStatus'){
            return this.getIntegrationStatusEntity(allowRemote);
        }
        if(fiendName === 'orderId'){
            return this.getOrderIdEntity(allowRemote);
        }
        if(fiendName === 'port'){
            return this.getPortEntity(allowRemote);
        }
        if(fiendName === 'stateOfSubiektIntegration'){
            return this.getStateOfSubiektIntegrationEntity(allowRemote);
        }
        if(fiendName === 'statusShipment'){
            return this.getStatusShipmentEntity(allowRemote);
        }
        if(fiendName === 'transportType'){
            return this.getTransportTypeEntity(allowRemote);
        }
        if(fiendName === 'typeOfDocument'){
            return this.getTypeOfDocumentEntity(allowRemote);
        }
        if(fiendName === 'warehouse'){
            return this.getWarehouseEntity(allowRemote);
        }
        return null;
    }


    /**
     * @param {string} externalSystemName
     * @returns {Promise<string>}
     */
    async externalId(externalSystemName){
        //clazzName, silkId, extSystem
        return Rpc.Integrations.silkIdToExternalId(FULL_CLASS, this.id, externalSystemName);
    }

    /**
     * @param {string} externalSystemName
     * @param {string} externalId
     * @returns {Promise<>}
     */
    async loadByExternalId(externalSystemName, externalId){
    //clazzName, silkId, extSystem
        let res = await Rpc.Integrations.externalIdToSilk(FULL_CLASS, externalId, externalSystemName);
        if(res.recordStatus !== "EXISTS"){
            throw new RpcNotFoundException({originalMessage:`Record status: ${res.recordStatus}`});
        }
        await this.load(res.silkId);
    }

    /**
     * @param {string} externalSystemName
     * @param {string} externalId
     * @returns {Promise<>}
     */
    async bindExternalId(externalSystemName, externalId){
      //clazzName, extId, extSystem, silkId
      return Rpc.Integrations.setMapping(FULL_CLASS, externalId, externalSystemName, this.id);
   }

    /**
     * @param {string} externalSystemName
     * @param {string} externalId
     * @returns {Promise<>}
     */
    async removeExternalId(externalSystemName, externalId){
        //clazzName, silkId, extSystem
        return Rpc.Integrations.clearMapping(FULL_CLASS, externalId, externalSystemName, this.id);
    }

    /**
     * @param {string} externalSystemName
     * @param {string} keyName
     * @returns {Promise<string>}
     */
    async readBoundValue(externalSystemName, keyName){
      let res = await Rpc.Integrations.readObjectData(FULL_CLASS, this.id, externalSystemName, keyName);
      return JSON.parse(res);
    }

    /**
     * @param {string} externalSystemName
     * @param {string} keyName
     * @param {Object} val
     * @returns {Promise<>}
     */
    async bindValue(externalSystemName, keyName, val){
      return Rpc.Integrations.storeObjectData(FULL_CLASS, externalSystemName, this.id, keyName, val);
    }

    /** @returns {string} */
    getRemoteClass(){
        return FULL_CLASS;
    }
}

/**
 * @param {string} id
 * @param {boolean?} loadFkObjects
 * @returns {Promise<Tranche>}
 */
async function loadTranche(id, loadFkObjects){
    if(loadFkObjects){
        return Rpc.Forms.getExtendedEntity(FULL_CLASS, id);
    }
    return Rpc.Forms.getEntity(FULL_CLASS, id);
}

/**
 * @returns {Promise<Tranche[]>}
 */
async function listTranche(){
    return Rpc.Forms.listEntities(FULL_CLASS);
}

/**
 * @param {string} id
 * @returns {Promise<string>}
 */
async function labelTranche(id){
    return Rpc.Forms.getEntityLabel(FULL_CLASS, id);
}
// STATICS --------------------------------------

/**
 * @param {string} id
 * @param {boolean?} loadDetails
 * @returns {Promise<Tranche>}
 */
Tranche.load = async function(id, loadDetails=false){
    if(loadDetails){
        return Rpc.Forms.getExtendedEntity(FULL_CLASS, id);
    }
    return Rpc.Forms.getEntity(FULL_CLASS, id);
}

/**
 * @returns {Promise<Tranche[]>}
 */
Tranche.list = async function(){
    return Rpc.Forms.listEntities(FULL_CLASS);
}

/**
 * @returns {Promise<Tranche[]>}
 */
Tranche.listExtended = async function(){
    return Rpc.Forms.listExtendedEntities(FULL_CLASS);
}

/**
 * @returns {Promise<Tranche[]>}
 */
Tranche.getRemoteClass = function(){
    return FULL_CLASS;
}

/**
 * @param {string} externalSystem
 * @param {string} extId
 * @param {boolean?} loadDetails
 * @returns {Promise<Tranche>}
 */
Tranche.loadByExternalId = async function(externalSystem, extId, loadDetails=false){

    let res = await Rpc.Integrations.externalIdToSilk(FULL_CLASS, extId, externalSystem);
    if(res.recordStatus !== "EXISTS"){
        throw new RpcNotFoundException({originalMessage:`Record status: ${res.recordStatus}`});
    }
    return Tranche.load(res.silkId, loadDetails);
}


// INTEGRATIONS --------------------------------

/**
 * @param {string} externalSystemName
 * @param {string} silkId
 * @returns {Promise<IdMapping>}
 */
Tranche.bindingFromSilkId = async function(externalSystemName, silkId){
    //clazzName, silkId, extSystem
    return Rpc.Integrations.silkIdToExternalId(FULL_CLASS, silkId, externalSystemName);
}

/**
 * @param {string} externalSystemName
 * @param {string} externalId
 * @returns {Promise<IdMapping>}
 */
Tranche.bindingFromExternalId = async function(externalSystemName, externalId){
    //clazzName, silkId, extSystem
    return  Rpc.Integrations.externalIdToSilk(FULL_CLASS, externalId, externalSystemName);
}

/**
 * @param {string} externalSystemName
 * @param {string} externalId
 * @param {string} silkId
 * @returns {Promise<>}
 */
Tranche.bindExternalId = async function(externalSystemName, externalId, silkId){
    //clazzName, extId, extSystem, silkId
    return Rpc.Integrations.setMapping(FULL_CLASS, externalId, externalSystemName, silkId);
}

/**
 * @param {string} externalSystemName
 * @param {string} externalId
 * @returns {Promise<>}
 */
Tranche.removeExternalId = async function(externalSystemName, externalId, silkId){
    //clazzName, silkId, extSystem
    return Rpc.Integrations.clearMapping(FULL_CLASS, externalId, externalSystemName, silkId);
}

/**
 * @param {IdMapping} binding
 * @returns {Promise<>}
 */
Tranche.removeExternalBinding = async function(binding){
    //clazzName, silkId, extSystem
    return Rpc.Integrations.clearMapping(FULL_CLASS, binding.externalId, binding.externalSystem, binding.silkId);
}



let metadata = {};
metadata['CBMField'] = {'remoteType' : 'java.math.BigDecimal', 'jsType' : 'BigDecimal', 'mapped' : 'true'};
metadata['EID'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['ETDConfirmed'] = {'remoteType' : 'java.time.LocalDate', 'jsType' : 'LocalDate', 'mapped' : 'true'};
metadata['ETDConfirmedWarning'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['SKUNumberOfOrdersForTheColorVersion'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['__archived'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['__familyId'] = {'remoteType' : 'number', 'jsType' : 'number', 'mapped' : 'false'};
metadata['__hidden'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['__parent'] = {'remoteType' : 'number', 'jsType' : 'number', 'mapped' : 'false'};
metadata['__versionDate'] = {'remoteType' : 'java.time.Instant', 'jsType' : 'Date', 'mapped' : 'true'};
metadata['_translations'] = {'remoteType' : 'Object.<string, *>', 'jsType' : 'Object.<string, *>', 'mapped' : 'false'};
metadata['attachments'] = {'remoteType' : 'module:src/server/com/silkplm/model/files/FileInRepository.FileInRepository[]', 'jsType' : 'module:src/server/com/silkplm/model/files/FileInRepository.FileInRepository[]', 'mapped' : 'false'};
metadata['booking'] = {'remoteType' : 'java.time.LocalDate', 'jsType' : 'LocalDate', 'mapped' : 'true'};
metadata['cartonsField'] = {'remoteType' : 'java.math.BigDecimal', 'jsType' : 'BigDecimal', 'mapped' : 'true'};
metadata['country'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['currentSelectedRegion'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['date'] = {'remoteType' : 'java.time.LocalDate', 'jsType' : 'LocalDate', 'mapped' : 'true'};
metadata['dateOfInvoice'] = {'remoteType' : 'java.time.LocalDate', 'jsType' : 'LocalDate', 'mapped' : 'true'};
metadata['deliveryPort'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['deliveryType'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['descriptionDPP'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['documents'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['grossWeight'] = {'remoteType' : 'java.math.BigDecimal', 'jsType' : 'BigDecimal', 'mapped' : 'true'};
metadata['id'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['inspection'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['integrationStatus'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['invoiceNumberField'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['noAdditionalCosts'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['numberOfTranche'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['orderId'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['port'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['rawMaterialsPath'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['realEXW'] = {'remoteType' : 'java.time.LocalDate', 'jsType' : 'LocalDate', 'mapped' : 'true'};
metadata['recordMetadata'] = {'remoteType' : 'module:src/server/com/silkplm/engine/entities/tracking/RecordMetadata.RecordMetadata', 'jsType' : 'module:src/server/com/silkplm/engine/entities/tracking/RecordMetadata.RecordMetadata', 'mapped' : 'false'};
metadata['stateOfSubiektIntegration'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['statusShipment'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['transportType'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['typeOfDocument'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['valueOfInvoice'] = {'remoteType' : 'java.math.BigDecimal', 'jsType' : 'BigDecimal', 'mapped' : 'true'};
metadata['version'] = {'remoteType' : 'number', 'jsType' : 'number', 'mapped' : 'false'};
metadata['warehouse'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['aTA'] = {'computed' : true, 'remoteType' : 'java.time.LocalDate', 'jsType' : 'LocalDate', 'mapped' : 'true'};
metadata['aTD'] = {'computed' : true, 'remoteType' : 'java.time.LocalDate', 'jsType' : 'LocalDate', 'mapped' : 'true'};
metadata['balanceTotal'] = {'computed' : true, 'remoteType' : 'java.math.BigDecimal', 'jsType' : 'BigDecimal', 'mapped' : 'true'};
metadata['bookingPMApproval'] = {'computed' : true, 'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['confirmedETDValid'] = {'computed' : true, 'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['countryValid'] = {'computed' : true, 'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['currencyValid'] = {'computed' : true, 'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['depositDeducted'] = {'computed' : true, 'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['eTA'] = {'computed' : true, 'remoteType' : 'java.time.LocalDate', 'jsType' : 'LocalDate', 'mapped' : 'true'};
metadata['eTD'] = {'computed' : true, 'remoteType' : 'java.time.LocalDate', 'jsType' : 'LocalDate', 'mapped' : 'true'};
metadata['invoiceNumber'] = {'computed' : true, 'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['orderNumberERP'] = {'computed' : true, 'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['orderValue'] = {'computed' : true, 'remoteType' : 'module:src/server/com/silkplm/rpc/dto/DecimalWithCurrency.DecimalWithCurrency', 'jsType' : 'module:src/server/com/silkplm/rpc/dto/DecimalWithCurrency.DecimalWithCurrency', 'mapped' : 'false'};
metadata['paymentDeadline'] = {'computed' : true, 'remoteType' : 'java.time.LocalDate', 'jsType' : 'LocalDate', 'mapped' : 'true'};
metadata['plannedDateOfInspection'] = {'computed' : true, 'remoteType' : 'java.time.LocalDate', 'jsType' : 'LocalDate', 'mapped' : 'true'};
metadata['portValid'] = {'computed' : true, 'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['productCategory'] = {'computed' : true, 'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['productsOnTranche'] = {'computed' : true, 'remoteType' : '*[]', 'jsType' : '*[]', 'mapped' : 'false'};
metadata['qCPMApproval'] = {'computed' : true, 'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['quantity'] = {'computed' : true, 'remoteType' : 'number', 'jsType' : 'number', 'mapped' : 'false'};
metadata['quantitySKU'] = {'computed' : true, 'remoteType' : 'number', 'jsType' : 'number', 'mapped' : 'false'};
metadata['valuePLN'] = {'computed' : true, 'remoteType' : 'java.math.BigDecimal', 'jsType' : 'BigDecimal', 'mapped' : 'true'};
metadata['warehouseIntegrationCode'] = {'computed' : true, 'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['orderIdNumberOfOrder'] = {'computed' : true, 'remoteType' : 'number', 'jsType' : 'number', 'mapped' : 'false'};
metadata['orderIdSeasonId'] = {'computed' : true, 'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['orderIdSupplierIdSupplierCode'] = {'computed' : true, 'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['orderIdSupplierId'] = {'computed' : true, 'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};

metadata.__type__ = 'com.silkplm.model.plm.Tranche';
metadata.__type_short__ = 'Tranche';
Tranche.prototype.__metadata__ = metadata;

Tranche.prototype.__cls__ = FULL_CLASS;

/** @module src/server/com/silkplm/model/plm/Tranche */
export default Tranche

export { Tranche , loadTranche, listTranche, labelTranche }
